import type {
  IFormField,
  IFormState,
} from '@vimcar/shared-components/components/IForm'

import linkViewModel from '@vimcar/mvvm/linkViewModel'
import { iFormField } from '@vimcar/shared-components/components/IForm'
import cx from 'classnames'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import styles from './styles.css'
import mkViewModel from './viewModel'

type Props = {
  viewModel: ViewModel
  field: IFormField<string>
  iForm: IFormState<unknown>
  placeholder?: string
  dark?: boolean
  className?: string
}

const TextArea = ({
  iForm: _,
  viewModel,
  field,
  dark,
  className,
  ...props
}: Props) => (
  <div>
    <textarea
      className={cx(
        styles.input,
        { [styles.dark]: dark, [styles.error]: field.showError && field.error },
        className,
      )}
      onBlur={viewModel.handleBlur}
      onChange={viewModel.handleChange}
      onFocus={viewModel.handleFocus}
      placeholder={viewModel.placeholder}
      readOnly={field.readOnly}
      value={field.display || ''}
      {...props}
    />
    <p className={styles.errorText}>
      {field.showError ? field.error : '\u00A0'}
    </p>
  </div>
)

const component = iFormField(linkViewModel(mkViewModel, TextArea))
component.displayName = 'TextArea'
export default component
